import React from 'react';
import { Translate } from 'react-redux-i18n';

class HeaderPopup extends React.Component {
  closePopup = () => {
    const { handleClickOutside } = this.props;
    handleClickOutside();
  };

  render() {
    return (
      <div className="header-popup">
        <div className="icon-setting">
          <div className="wrap-icon">
            <i className="icon-settings" />
          </div>
          <Translate value={`systemSetting.title`} />
        </div>
        <a href="#" onClick={this.closePopup}>
          <i className="icon-close text-stock-chart" />
        </a>
      </div>
    );
  }
}

export default HeaderPopup;
